import { Button, ButtonProps } from '@akin-home/buttons/native';

export const ScreenSaveButton = (props: ButtonProps) => (
  <Button icon="check" size="large" iconSize={20} {...props}>
    Save
  </Button>
);
